import { Component, inject } from '@angular/core';

import { NotificationComponent } from '@gfe/core/components/notification/notification.component';
import { NotificationService } from '@gfe/core/services/notification/notification.service';

@Component({
  selector: 'app-notification-container',
  imports: [NotificationComponent],
  templateUrl: './notification-container.component.html',
  styleUrl: './notification-container.component.css'
})
export class NotificationContainerComponent {
  private notificationService = inject(NotificationService);

  notifications = this.notificationService.notificationsList;
  hasNotifications = this.notificationService.hasNotifications;
  config = this.notificationService.notificationsConfig;

  onDismiss(notificationId: string): void {
    this.notificationService.dismiss(notificationId);
  }

  onPause(notificationId: string): void {
    this.notificationService.pauseTimer(notificationId);
  }

  onResume(notificationId: string): void {
    this.notificationService.resumeTimer(notificationId);
  }

  dismissAll(): void {
    this.notificationService.dismissAll();
  }
}
